import React from 'react';
import { motion } from 'framer-motion';
import { BatteryLow, Clock, ShoppingBag, UtensilsCrossed } from 'lucide-react';
const failures = [{
  icon: <BatteryLow className="w-8 h-8 text-red-500" data-id="element-13" />,
  title: "The 'Digital Babysitter' Backfires",
  desc: "It works until the battery dies, the WiFi drops, or the headphones simply won't stay on their tiny heads."
}, {
  icon: <Clock className="w-8 h-8 text-brand-orange" data-id="element-14" />,
  title: 'Novelty Burnout',
  desc: 'Giving them all their toys at once leads to total boredom in the first 20 minutes of a 4-hour flight.'
}, {
  icon: <ShoppingBag className="w-8 h-8 text-purple-500" data-id="element-15" />,
  title: 'Airport Shop Panic Buys',
  desc: "Those 'new' toys are usually too loud, too messy, or have tiny pieces that roll under the seat forever."
}, {
  icon: <UtensilsCrossed className="w-8 h-8 text-green-500" data-id="element-16" />,
  title: 'Airline Snack Roulette',
  desc: "Relying on the airline means you're at the mercy of a cart that might not reach your row for an hour."
}];
export function FailedSolutionsSection() {
  return <section className="py-10 md:py-16 bg-brand-cream" data-id="element-17">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-19">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-3" data-id="element-20">
            Why What You Tried Didn't Work
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-21">
            If you've struggled before, it's not your fault. The standard advice
            sets parents up for failure.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-22">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 flex gap-4 items-start hover:shadow-md transition-shadow" data-id="element-23">
              <div className="p-3 bg-gray-50 rounded-xl shrink-0" data-id="element-24">
                {item.icon}
              </div>
              <div data-id="element-25">
                <h3 className="text-lg font-bold text-brand-dark mb-1" data-id="element-26">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-27">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}